/**
 * Sign-in framing from OAuth return path (`?next=`).
 * Headlines name the task; detail sets expectation for what happens after OAuth.
 */

/** Reject open redirects; only same-origin relative paths are allowed. */
export function sanitizeLoginNext(raw) {
  const next = (raw || "").trim();
  if (!next.startsWith("/") || next.startsWith("//")) return "/events";
  return next;
}

export function loginContextForNext(next) {
  const sanitized = sanitizeLoginNext(next);
  const path = sanitized.split("?")[0];
  const hostTab = path === "/me/host" || sanitized.includes("tab=host");

  if (path === "/onboarding") {
    return {
      headline: "Sign in to finish setup",
      detail: "We'll pick up your host onboarding as soon as you're signed in.",
      pageTitle: "Sign in to set up — rsvp.dance",
      footnote: null,
    };
  }

  if (path === "/create") {
    return {
      headline: "Sign in to publish your event",
      detail: "Your draft is saved on this phone. Pick Google or Apple to finish.",
      pageTitle: "Sign in to publish — rsvp.dance",
      footnote: null,
    };
  }

  if (/^\/e\/[^/]+\/edit$/.test(path)) {
    return {
      headline: "Sign in to finish your event",
      detail: "We'll reopen your draft as soon as you're signed in.",
      pageTitle: "Sign in to finish your event — rsvp.dance",
      footnote: null,
    };
  }

  if (hostTab || path === "/me/host") {
    return {
      headline: "Sign in to set up hosting",
      detail: "Add payment defaults and your public host page next.",
      pageTitle: "Sign in to host — rsvp.dance",
      footnote: null,
    };
  }

  if (path === "/me") {
    return {
      headline: "Sign in to save your dance details",
      detail: "Link this phone so your role and dances carry over next time.",
      pageTitle: "Sign in to save your profile — rsvp.dance",
      footnote: {
        text: "Free for guests — we never charge you to RSVP.",
      },
    };
  }

  if (path.startsWith("/dashboard/")) {
    return {
      headline: "Sign in as host",
      detail: "Guest list, check-in, and share tools unlock after sign-in.",
      pageTitle: "Sign in to your dashboard — rsvp.dance",
      footnote: null,
    };
  }

  if (path.includes("check-in")) {
    return {
      headline: "Sign in to check in guests",
      detail: "You'll return to the door list right after sign-in.",
      pageTitle: "Sign in to check in — rsvp.dance",
      footnote: null,
    };
  }

  const schoolFollow =
    (/^\/school\//.test(path) || /^\/schools\//.test(path))
    && new URLSearchParams(sanitized.split("?")[1] || "").get("follow") === "1";
  if (schoolFollow) {
    return {
      headline: "Sign in to follow this school",
      detail: "Following saves this school to your account so you can find it again after you come back.",
      pageTitle: "Sign in to follow — rsvp.dance",
      footnote: null,
    };
  }

  if (path === "/events") {
    return {
      headline: "Sign in to see your feed",
      detail: "RSVPs on this phone will link to your account.",
      pageTitle: "Sign in — rsvp.dance",
      footnote: {
        text: "Hosting a social?",
        link: { to: "/onboarding", label: "Set up hosting after you sign in" },
      },
    };
  }

  return {
    headline: "Sign in to continue",
    detail: "We'll bring you back to where you left off.",
    pageTitle: "Sign in — rsvp.dance",
    footnote: {
      text: "Hosting a social?",
      link: { to: "/onboarding", label: "Set up hosting after you sign in" },
    },
  };
}
